import React, { useContext, useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { AuthContext } from "./contexts/AuthContext";
import { userService } from "./services/api/authenService";
import SessionExpiredModal from "./pages/components/SessionExpiredModal";
import { setSessionExpiredHandler } from "./configs/axios.config";
import { accountService } from "./services/api/accountService";
import ScreenSizeChecker from "./pages/components/ScreenSizeChecker";
import AppRoutes from "./routes/appRoutes";

function App() {
  const { dispatch, token_client } = useContext(AuthContext);
  const [isSessionExpired, setSessionExpired] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setSessionExpiredHandler(() => setSessionExpired(true));
  }, []);

  // Verify session on app load to detect deleted accounts
  useEffect(() => {
    const verifySession = async () => {
      if (token_client) {
        try {
          await accountService.get_me(token_client);
        } catch (error) {
          const status = error.response?.status;
          // If 401, it means the token is invalid or the user account is gone/disabled
          if (status === 401) {
            console.warn("Session invalid, logging out...");
            toast.error("Tài khoản của bạn đã bị khóa hoặc xóa!");
            dispatch({ type: "LOGOUT" });
            window.location.href = "/login";
          }
        }
      }
    };

    verifySession();
  }, [token_client, dispatch]);

  const handleLogout = async () => {
    try {
      await userService.log_out();
      dispatch({ type: "LOGOUT" });
      toast.success("Đăng xuất thành công!");
      window.location.href = "/login";
    } catch (error) {
      toast.dismiss();
      toast.error("Đăng xuất không thành công!");
      console.error("Error:", error);
    }
  };

  return (
    <>
      <ScreenSizeChecker onScreenSizeChange={setIsMobile} />
      <ToastContainer position="bottom-right" autoClose={5000} theme="light" />
      <AppRoutes isMobile={isMobile} />
      {isSessionExpired && (
        <SessionExpiredModal visible onLogout={handleLogout} />
      )}
    </>
  );
}

export default App;
